import React, { Component } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import CustomSwiper from 'components/CustomSwiper';

import { productsSwiperSettings } from 'configs/productsSwiperSettings';
import * as commonService from 'services/commonService';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

const SlickButton = ({ currentSlide, slideCount, children, ...props }) => <span {...props}>{children}</span>;
const productsData = {
	name: 'Related items',
	products: [
		{
			id: 1,
			name: 'Organic Onions',
			image: require('assets/imgs/prdctImages/medium/mdm1.png'),
			variant: '1 KG',
			price: 56,
			qty: 1
		},
		{
			id: 2,
			name: 'Ladies fingers',
			image: require('assets/imgs/prdctImages/medium/mdm2.png'),
			variant: '0.5 KG',
			price: 40,
			qty: 0
		},
		{
			id: 3,
			name: 'Organic Tomato',
			image: require('assets/imgs/prdctImages/medium/mdm3.png'),
			variant: '1 KG',
			price: 125,
			qty: 2
		},
		{
			id: 4,
			name: 'Banana - Nendran',
			image: require('assets/imgs/prdctImages/medium/mdm4.png'),
			variant: '1 KG',
			price: 32,
			qty: 0
		},
		{
			id: 1,
			name: 'Organic Onions',
			image: require('assets/imgs/prdctImages/medium/mdm1.png'),
			variant: '1 KG',
			price: 56,
			qty: 0
		},
		{
			id: 2,
			name: 'Ladies fingers',
			image: require('assets/imgs/prdctImages/medium/mdm2.png'),
			variant: '0.5 KG',
			price: 40,
			qty: 1
		},
		{
			id: 3,
			name: 'Organic Tomato',
			image: require('assets/imgs/prdctImages/medium/mdm3.png'),
			variant: '1 KG',
			price: 125,
			qty: 0
		},
		{
			id: 4,
			name: 'Banana - Nendran',
			image: require('assets/imgs/prdctImages/medium/mdm4.png'),
			variant: '1 KG',
			price: 32,
			qty: 1
		},
		{
			id: 1,
			name: 'Organic Onions',
			image: require('assets/imgs/prdctImages/medium/mdm1.png'),
			variant: '1 KG',
			price: 56,
			qty: 0
		},
		{
			id: 2,
			name: 'Ladies fingers',
			image: require('assets/imgs/prdctImages/medium/mdm2.png'),
			variant: '0.5 KG',
			price: 40,
			qty: 1
		},
		{
			id: 3,
			name: 'Organic Tomato',
			image: require('assets/imgs/prdctImages/medium/mdm3.png'),
			variant: '1 KG',
			price: 125,
			qty: 0
		},
		{
			id: 4,
			name: 'Banana - Nendran',
			image: require('assets/imgs/prdctImages/medium/mdm4.png'),
			variant: '1 KG',
			price: 32,
			qty: 0
		},
		{
			id: 1,
			name: 'Organic Onions',
			image: require('assets/imgs/prdctImages/medium/mdm1.png'),
			variant: '1 KG',
			price: 56,
			qty: 1
		}
	]
};

class ProductPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			productId: null,
			product: null,
			qty: 1,
			selectedVariant: null
		};

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

		commonService.onLoadFunction();
	}
	componentDidMount() {
		if (this.props.match.params && this.props.match.params.productId) {
			let productId = this.props.match.params.productId;
			this.setState({ productId });

			this.props.setProductDetailsLoader(true);
			this.props.getProductDetails(productId);
		}
	}
	componentDidUpdate(prevProps) {
		if (
			(!this.state.product && this.props.productDetails) ||
			prevProps.productDetails !== this.props.productDetails
		) {
			let product = this.props.productDetails;
			this.setState({ product: this.props.productDetails });
			if (product.variant_data) {
				if (
					product.has_variants &&
					!product.show_variant_picker &&
					product.variant_data &&
					product.variant_data.variants &&
					Object.keys(product.variant_data.variants).length > 0
				) {
					let key = Object.keys(product.variant_data.variants)[0];
					this.handleNormalVariantChange(key, product);
				}

				if (
					product.has_variants &&
					product.show_variant_picker &&
					product.variant_data &&
					product.variant_data.variantAttributes &&
					product.variant_data.variantAttributes.length > 0
				) {
					let selectedVariantData = product.variant_data.variantAttributes[0];
					if (selectedVariantData.values && selectedVariantData.values.length > 0) {
						let value = selectedVariantData.values[0];
						let key = selectedVariantData.pk.toString() + value.pk.toString();
						this.handleVariantChange(key, product);
					}
				}
			}
		}
	}
	handleNormalVariantChange = (key, product) => {
		let selectedVariant = product.variant_data.variants[key];
		selectedVariant.key = key;
		this.setState({ selectedVariant });
	};
	handleVariantChange = (key, product) => {
		if (product.variant_data.variants && Object.keys(product.variant_data.variants).length > 0) {
			let selectedVariant = product.variant_data.variants[key];
			if (selectedVariant) {
				selectedVariant.key = key;
				this.setState({ selectedVariant });
			}
		}
	};
	handleAddToCart = () => {
		let { selectedVariant } = this.state;
		if (selectedVariant) {
			let data = {
				variantId: selectedVariant.id,
				quantity: this.state.qty,
				type: 'add'
			};
			this.props.setUpdateCartItemLoader(true);
			this.props.updateCartItem(data);
		}
	};
	render() {
		const { loadingProductDetails, updatingCartItem } = this.props;
		const { product, selectedVariant } = this.state;

		const settings = {
			dots: true,
			arrows: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: (
				<SlickButton>
					<i className="fa fa-angle-left" aria-hidden="true" />
				</SlickButton>
			),
			nextArrow: (
				<SlickButton>
					<i className="fa fa-angle-right" aria-hidden="true" />
				</SlickButton>
			),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false
					}
				}
			]
		};

		return (
			<div className="productPage">
				<Header history={this.props.history} from="product" />
				{loadingProductDetails ? (
					<div className="py-5 text-center">
						<h1 className="py-5">Loading...</h1>
					</div>
				) : (
					<div className="mt-4 mt-md-5 mx-0 mx-sm-2 mx-md-5 pt-0 pt-md-3 pb-3 pb-md-5 productDetails">
						{product && (
							<div className="w-100">
								<div className="row m-0">
									<div className="col-md-6 px-0 px-md-3">
										<div className="pl-0 pl-lg-3">
											<Slider {...settings}>
												{product.image_urls &&
													product.image_urls.map((imageUrls, index) => (
														<img key={index} src={imageUrls.m} className="w-100" alt="" />
													))}
											</Slider>
										</div>
									</div>
									<div className="col-md-6 pt-5 pt-md-0">
										<div className="pl-0 pl-md-3 pl-lg-5 details">
											<h1 className="m-0 name mb-1">{product.name}</h1>
											<p className="stock m-0">Vegetables | In stock</p>
											<p className="price my-3">
												₹ {selectedVariant ? selectedVariant.price : product.price}
											</p>
											{product.in_stock ? (
												<React.Fragment>
													<div className="d-flex flex-row align-items-center qtySection mb-4">
														<select
															className="form-control m-0"
															value={this.state.qty}
															onChange={(e) => this.setState({ qty: e.target.value })}
														>
															<option value="1">1</option>
															<option value="2">2</option>
															<option value="3">3</option>
															<option value="4">4</option>
															<option value="5">5</option>
														</select>
														<p className="sym">X</p>
														<p>
															₹ {selectedVariant ? selectedVariant.price : product.price}
														</p>
														<p className="sym">=</p>
														<p>
															₹{' '}
															{this.state.qty *
																(selectedVariant
																	? selectedVariant.price
																	: product.price)}
														</p>
													</div>
													{product.has_variants &&
													!product.show_variant_picker && (
														<div data={Object.keys(product.variant_data.variants)}>
															{product.variant_data &&
															product.variant_data.variants &&
															Object.keys(product.variant_data.variants).length > 0 && (
																<select
																	className="form-control w-auto"
																	value={selectedVariant ? selectedVariant.key : ''}
																	onChange={(e) =>
																		this.handleNormalVariantChange(
																			e.target.value,
																			product
																		)}
																>
																	{Object.keys(
																		product.variant_data.variants
																	).map((key, index) => (
																		<option
																			key={index}
																			disabled={
																				!product.variant_data.variants[key]
																					.availability
																			}
																			value={key}
																		>
																			{key}
																		</option>
																	))}
																</select>
															)}
														</div>
													)}

													{product.has_variants &&
													product.show_variant_picker && (
														<React.Fragment>
															{product.variant_data &&
																product.variant_data.variantAttributes &&
																product.variant_data.variantAttributes.map(
																	(variantSection, index) => (
																		<React.Fragment key={index}>
																			{variantSection.values &&
																			variantSection.values.length > 0 && (
																				<div className="variantSection my-2">
																					<p className="m-0 name">
																						{variantSection.name}:
																					</p>
																					<div className="variants pt-2">
																						{variantSection.values.map(
																							(value, index1) => (
																								<div
																									className={classNames(
																										'variant',
																										selectedVariant &&
																										selectedVariant.key ===
																											variantSection.pk.toString() +
																												value.pk.toString()
																											? 'active'
																											: ''
																									)}
																									key={index1}
																									onClick={() =>
																										this.handleVariantChange(
																											variantSection.pk.toString() +
																												value.pk.toString(),
																											product
																										)}
																								>
																									<p className="m-0">
																										{value.name}
																									</p>
																								</div>
																							)
																						)}
																					</div>
																				</div>
																			)}
																		</React.Fragment>
																	)
																)}
														</React.Fragment>
													)}
													<button
														className="mt-4 addToBag"
														disabled={
															(selectedVariant && !selectedVariant.availability) ||
															(updatingCartItem && updatingCartItem !== 'updated')
														}
														onClick={this.handleAddToCart}
													>
														{updatingCartItem && updatingCartItem !== 'updated' ? (
															'ADDING TO BAG'
														) : (
															'ADD TO BAG'
														)}
													</button>
												</React.Fragment>
											) : (
												<div>
													<p
														className="m-0 price"
														style={{ color: 'red', fontWeight: '400' }}
													>
														Out of Stock
													</p>
												</div>
											)}
											<div style={{ border: '1px dashed rgb(199 199 199)' }} className="my-4" />
											<div className="desc">
												<h4>Description</h4>
												<p className="m-0">{product.description}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				)}
				<div className="px-1 px-sm-2 px-md-3 px-lg-5 pb-1 pt-1" style={{ background: '#F7FBFF' }}>
					<CustomSwiper
						data={productsData}
						settings={productsSwiperSettings}
						type="productsSwiper"
						history={this.props.history}
					/>
				</div>
				<Footer />
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getProductDetails: Actions.getProductDetails,
			setProductDetailsLoader: Actions.setProductDetailsLoader,

			updateCartItem: Actions.updateCartItem,
			setUpdateCartItemLoader: Actions.setUpdateCartItemLoader
		},
		dispatch
	);
}
function mapStateToProps(reducer) {
	const homeReducer = reducer.homeReducer;
	const cartReducer = reducer.cartReducer;
	return {
		loadingProductDetails: homeReducer.loadingProductDetails,
		productDetails: homeReducer.productDetails,

		updatingCartItem: cartReducer.updatingCartItem
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
